import { z } from 'zod';

export const JobStage = z.enum(['draft', 'matching', 'active', 'complete']);
export type JobStage = z.output<typeof JobStage>;

export const MatchingStage = z.enum([
  'finding_tutors',
  'receiving_applications',
  'tutors_shortlisted',
  'tutor_interview',
  'tutor_selected',
]);
export type MatchingStage = z.output<typeof MatchingStage>;

export const ReportCadence = z.enum([
  'monthly',
  'bi_monthly',
  'quarterly',
  'disabled',
]);
export type ReportCadence = z.output<typeof ReportCadence>;

export const JobSchedule = z.enum(['any', 'weekday', 'weekend']);
export type JobSchedule = z.output<typeof JobSchedule>;

export const JobFormat = z.enum([
  'offline_required',
  'offline_preferred',
  'online_required',
  'online_preferred',
  'either',
]);
export type JobFormat = z.output<typeof JobFormat>;

export const ApplicationStage = z.enum([
  'pending',
  'shortlisted',
  'rejected',
  'won',
  'interview',
]);
export type ApplicationStage = z.output<typeof ApplicationStage>;

// Staff and auth
export const StaffRole = z.enum([
  'client_tutor_management',
  'billing',
  'super_admin',
]);
export type StaffRole = z.output<typeof StaffRole>;

export const UserRole = z.enum(['staff', 'tutor', 'client']);
export type UserRole = z.output<typeof UserRole>;

// Contact
export const ContactType = z.enum([
  'parent',
  'relative',
  'guardian',
  'third_party',
  'school_staff',
]);
export type ContactType = z.output<typeof ContactType>;

// Lessons and billing
export const LessonStatus = z.enum([
  'pending',
  'approved',
  'invoiced',
  'paid',
]);
export type LessonStatus = z.output<typeof LessonStatus>;

export const LedgerStatus = z.enum([
  'requires_payment_method',
  'requires_confirmation',
  'requires_action',
  'processing',
  'requires_capture',
  'canceled',
  'succeeded',
  'draft',
  'open',
  'paid',
  'uncollectible',
  'void',
]);
export type LedgerStatus = z.output<typeof LedgerStatus>;

export const Currency = z.enum(['gbp', 'hkd', 'sgd']);
export type Currency = z.output<typeof Currency>;

export const BillingType = z.enum([
  'automatic',
  'manual',
  'payment_upfront',
  'monthly',
]);
export type BillingType = z.output<typeof BillingType>;

export const TutorType = z.enum(['professional', 'self_employed']);
export type TutorType = z.output<typeof TutorType>;

// Tutor status enums
export const TutorStatus = z.enum([
  'pending',
  'shortlisted',
  'rejected',
  'selected',
  'withdrawn',
]);
export type TutorStatus = z.output<typeof TutorStatus>;

// Job tutor status enum (specific to job-tutors-status-view)
export const JobTutorStatus = z.enum([
  'Applied',
  'Draft',
  'Not Interested',
  'Notified',
  'Pending',
  'Rejected',
  'Selected',
  'Shortlisted',
  'Interview',
  'Unknown',
]);
export type JobTutorStatus = z.output<typeof JobTutorStatus>;

export const LessonLineItemType = z.enum(['lesson', 'expense']);
export type LessonLineItemType = z.output<typeof LessonLineItemType>;

export const JobPermission = z.enum([
  'owner',
  'billing',
  'reports',
  'operations',
]);
export type JobPermission = z.output<typeof JobPermission>;

export const Vat = z.enum(['vat', 'no_vat', 'gst']);
export type Vat = z.output<typeof Vat>;
